import {
  Hourglass,
  LoaderCircle,
  MessagesSquare,
  GitBranch,
  GitFork,
  Folder,
  Paperclip,
  FileText,
  Info,
  ArrowRight,
  UsersRound,
  Cpu,
  Gauge,
  History,
  Settings,
  Compass,
  Bot,
  Brain,
  Rocket,
  Hand,
  MessageCircleQuestion,
  BatteryLow,
  PiggyBank,
  RefreshCcw,
  RefreshCw,
  WandSparkles,
  Sparkles,
  Star,
  FlaskConical,
  Mic,
  Keyboard,
  Clock,
  Zap,
  Send,
  Coins,
  Wrench,
  HardDrive,
  Play,
  Pause,
  XCircle,
  Copy,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  ExternalLink,
  Filter,
  Search,
  CheckCircle2,
  AlertTriangle,
  PlugZap,
  LogOut,
  ClipboardList,
  Megaphone,
  LockKeyhole,
  GitMerge,
  OctagonAlert,
  ListOrdered,
  KeyRound,
  Euro,
  Route,
  Plus,
  X,
  Eye,
  EyeOff,
  Fingerprint,
  Server,
  Maximize,
  Moon,
  Sun,
  Monitor,
  Trash2,
  ArrowLeft,
  ArrowDown,
  Menu,
  Pin,
  Lock,
  Check,
  Bell,
  Download,
  Circle,
  Inbox,
  Activity,
  Mail,
  Code2,
  Ban,
  Repeat,
  Tag,
  GitCommitHorizontal,
  CalendarClock,
  SquareTerminal,
  Box,
  Globe,
  Pencil,
  LayoutDashboard,
  User,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

const MAP: Record<string, LucideIcon> = {
  'messages-square': MessagesSquare,
  'git-branch': GitBranch,
  'git-fork': GitFork,
  folder: Folder,
  paperclip: Paperclip,
  'file-text': FileText,
  info: Info,
  'arrow-right': ArrowRight,
  'users-round': UsersRound,
  cpu: Cpu,
  gauge: Gauge,
  history: History,
  settings: Settings,
  compass: Compass,
  bot: Bot,
  brain: Brain,
  rocket: Rocket,
  hand: Hand,
  'message-circle-question': MessageCircleQuestion,
  'battery-low': BatteryLow,
  'piggy-bank': PiggyBank,
  'refresh-ccw': RefreshCcw,
  'refresh-cw': RefreshCw,
  'wand-sparkles': WandSparkles,
  sparkles: Sparkles,
  star: Star,
  'flask-conical': FlaskConical,
  mic: Mic,
  keyboard: Keyboard,
  clock: Clock,
  zap: Zap,
  send: Send,
  coins: Coins,
  wrench: Wrench,
  'hard-drive': HardDrive,
  play: Play,
  pause: Pause,
  'x-circle': XCircle,
  copy: Copy,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'chevron-right': ChevronRight,
  'external-link': ExternalLink,
  filter: Filter,
  search: Search,
  'check-circle-2': CheckCircle2,
  'alert-triangle': AlertTriangle,
  'plug-zap': PlugZap,
  'log-out': LogOut,
  'clipboard-list': ClipboardList,
  megaphone: Megaphone,
  'lock-keyhole': LockKeyhole,
  'git-merge': GitMerge,
  'octagon-alert': OctagonAlert,
  'list-ordered': ListOrdered,
  'key-round': KeyRound,
  euro: Euro,
  route: Route,
  plus: Plus,
  x: X,
  eye: Eye,
  'eye-off': EyeOff,
  fingerprint: Fingerprint,
  server: Server,
  maximize: Maximize,
  moon: Moon,
  sun: Sun,
  monitor: Monitor,
  trash: Trash2,
  'arrow-left': ArrowLeft,
  'arrow-down': ArrowDown,
  menu: Menu,
  pin: Pin,
  lock: Lock,
  check: Check,
  bell: Bell,
  download: Download,
  dot: Circle,
  inbox: Inbox,
  activity: Activity,
  mail: Mail,
  code: Code2,
  ban: Ban,
  repeat: Repeat,
  tag: Tag,
  'git-commit': GitCommitHorizontal,
  'calendar-clock': CalendarClock,
  terminal: SquareTerminal,
  box: Box,
  globe: Globe,
  pencil: Pencil,
  'layout-dashboard': LayoutDashboard,
  user: User,
  hourglass: Hourglass,
  loader: LoaderCircle,
};

export interface IconProps {
  name: string;
  size?: number;
  color?: string;
  className?: string;
}

export function Icon({ name, size = 16, color, className }: IconProps) {
  const C = MAP[name] ?? Circle;
  return (
    <C
      size={size}
      strokeWidth={1.5}
      color={color ?? 'currentColor'}
      className={className}
      aria-hidden
    />
  );
}
